var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"mask"},[_c('div',{staticStyle:{"width":"300px","height":"234px"},attrs:{"id":"__Verification"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }